angular.module('app').config(invoicesRouting);

function invoicesRouting($routeProvider) {
  $routeProvider
    .when('/invoices', {
      pageTitle: 'INVOICES',
      template: '<invoices-page></invoices-page>',
      menu: 'sales',
      accessPermission: 'index_invoice_accountadmin',
      authReq: true,
    })
    .when('/invoices/new', {
      params: {
        bookingId: null,
        currencyId: null,
        saleChannelId: null,
        saleSourceId: null,
        salePersonId: null,
        // fromBooking: null,
        bookingData: null,
        mode: null,
        clientId: null,
      },
      pageTitle: 'ADD_INVOICE',
      template: '<invoice-page></invoice-page>',
      breadcrumb: {
        label: 'INVOICES',
        parent: 'invoices',
        ajs: true,
      },
      menu: 'sales',
      accessPermission: 'create_invoice_accountadmin',
      authReq: true,
    })
    .when('/invoices/:id', {
      params: {
        mode: null,
        // fromBooking: null,
      },
      pageTitle: 'INVOICE',
      template: '<invoice-page></invoice-page>',
      breadcrumb: {
        label: 'INVOICES',
        parent: 'invoices',
        ajs: true,
      },
      menu: 'sales',
      accessPermission: 'show_invoice_accountadmin',
      authReq: true,
    });
}

invoicesRouting.$inject = ['$routeProvider'];
